module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNGQUQ0RDQiLz4KPHBhdGggZD0iTTcuNTQ0OTIgMTAuMDkxM0w4LjQ0MjE5IDEwLjk4ODVMMTEuMzYzMSA4LjA3Mzk5VjE4LjM2NEgxMi42MzU4VjguMDczOTlMMTUuNTU2NyAxMC45OTQ5TDE2LjQ1NCAxMC4wOTEzTDExLjk5OTUgNS42MzY3Mkw3LjU0NDkyIDEwLjA5MTNaIiBmaWxsPSIjRTc0RTUxIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-mark-up.svg
// module id = YOh5
// module chunks = 1